import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import React from "react";
import icon from "assets/images/SVG/CheckboxUnChecked.svg";
import checkedIcon from "assets/images/SVG/CheckboxChecked.svg";

const CheckboxGroup = ({
  label,
  name,
  options,
  onChange,
  value,
  labelPlacement = "end",
}) => {
  return (
    <FormControl sx={{ padding: "0.5rem 0", width: "100%" }}>
      {label && (
        <label htmlFor={name} className={`font-medium`}>
          {label}
        </label>
      )}
      <FormGroup aria-label={label} row>
        {options?.map((item) => {
          return (
            <FormControlLabel
              key={item?.value}
              value={item?.value}
              control={
                <Checkbox
                  icon={<img src={icon} alt="unchecked" />}
                  checkedIcon={<img src={checkedIcon} alt="checked" />}
                  value={item?.value}
                  checked={value?.includes(item?.value)}
                  onChange={(e) => {
                    if (onChange) {
                      onChange(e);
                    }
                  }}
                // name={item?.label}
                />
              }
              label={
                <span className="text-[#2D2A33] text-sm">
                  {item?.label}
                </span>
              }
              labelPlacement={labelPlacement}
            />
          );
        })}
      </FormGroup>
    </FormControl>
  );
};

export default CheckboxGroup;
